
import React, { useEffect, useState } from "react";
import Chartist from "react-chartist";
import ChartistTooltip from 'chartist-plugin-tooltips-updated';
import _, { max } from "lodash";
import ALL_MONTHS from "../utils/constValues";

export const SalesValueChart = (Salesdata={}) => {
  const incoming_data = Salesdata.salesData
  const default_labels = ALL_MONTHS.map((object) => object.short)
  const default_series = [[1, 2, 2, 3, 3, 4, 3]]
  const data = {
    labels: _.has(incoming_data, "labels") ? incoming_data.labels : default_labels,
    series: _.has(incoming_data, "series") ? [incoming_data.series] : default_series,
  };
  const options = {
    low: 0,
    showArea: true,
    fullWidth: true,
    axisX: {
      position: 'end',
      showGrid: true
    },
    chartPadding: {
      top: 15,
      right: 30,
      bottom: 5,
      left: 40,
    },
    axisY: {
      // On the y-axis start means left and end means right
      showGrid: false,
      showLabel: true,
      labelInterpolationFnc: value => `$${value / 1}k`
    }
  };

  const plugins = [
      ChartistTooltip({appendToBody: false,  transformTooltipTextFnc: value => `$${value / 1}k`, class: "test-tooltip", tooltipOffset: {x:-20, y: -180,}})
  ]

  console.log(data)

  return (
    <Chartist data={data} options={{...options, plugins}} type="Line" className="ct-series-g ct-double-octave" />
  );
};

export const SalesValueChartphone = () => {
  const data = {
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    series: [[1, 2, 2, 3, 3, 4, 3]]
  };

  const options = {
    low: 0,
    showArea: true,
    fullWidth: false,
    axisX: {
      position: 'end',
      showGrid: true
    },
    axisY: {
      // On the y-axis start means left and end means right
      showGrid: false,
      showLabel: false,
      labelInterpolationFnc: value => `$${value / 1}k`
    }
  };

  const plugins = [
    ChartistTooltip({appendToBody: false,  transformTooltipTextFnc: value => `$${value / 1}k`, class: "test-tooltip", tooltipOffset: {x:-20, y: -180,}})
  ]

  return (
    <Chartist data={data} options={{...options, plugins}} type="Line" className="ct-series-g ct-major-tenth" />
  );
};

export const CircleChart = (props) => {
  const { series = [], donutWidth = 20 } = props;
  const sum = (a, b) => a + b;

  const options = {
    low: 0,
    high: 8,
    donutWidth,
    donut: true,
    donutSolid: true,
    fullWidth: false,
    showLabel: false,
    labelInterpolationFnc: value => `${Math.round(value / series.reduce(sum) * 100)}%`,
  }

  const plugins = [
    ChartistTooltip({appendToBody: false,  transformTooltipTextFnc: value => `$${value / 1}k`, class: "test-tooltip", tooltipOffset: {x:-20, y: -180,}})
  ]

  return (
    <Chartist data={{ series }} options={{...options, plugins}} type="Pie" className="ct-golden-section" />
  );
};

export const BarChart = (props) => {
  const { labels = [], series = [], chartClassName = "ct-golden-section", transform=true, uniqueChartClass=""} = props;
  const data = { labels, series };

  const options = {
    low: 0,
    showArea: true,
    chartPadding: {
      top: 15,
      right: 30,
      bottom: 40,
      left: 100,
    },
    axisX: {
      position: 'end',
      scaleMinSpace: 10,
    },
    axisY: {
      showLabel: true,
      onlyInteger: true,
      position: 'start',
      showGrid: true,
      showLabel: true,
      labelOffset: {
        x: 0,
      },
      offset: 20,
      scaleMinSpace: 10
    }
  };

  const plugins = [
    ChartistTooltip({appendToBody: false,  transformTooltipTextFnc: transform ? value => `$${value / 1}k` : value => value, class: "test-tooltip", tooltipOffset: {x:-20, y: -180,}})
  ]

  return (
    <Chartist data={data} options={{...options, plugins}} type="Bar" className={chartClassName + uniqueChartClass} />
  );
};

export const HorizontalBarChart = (props) => {
  const { labels = [], series = [], chartClassName = "ct-golden-section" } = props;
  const data = { labels, series };
  const options = {
    low: 1,
    high: _.max(series[0]),
    referenceValue: null,
    chartPadding: {
      top: 15,
      right: 30,
      bottom: 5,
      left: 100,
    },
    horizontalBars: true,
    axisX: {
      position: 'end',
      onlyInteger: true,
      scaleMinSpace: 10,
    },
    axisY: {
      position: 'start',
      showGrid: true,
      showLabel: true,
      labelInterpolationFnc: (value, index) => `(${series[0][index]})${value.split(',')[0]}`,
      labelOffset: {
        x: 0,
      },
      offset: 30
    }
  };
  const plugins = [
    ChartistTooltip({appendToBody: true, anchorToPoint: true,  transformTooltipTextFnc: value => `$${value}`, class: "test-tooltip", tooltipOffset: {x:-20, y: -180,}})
  ]

  return (
    <Chartist data={data} options={{...options, plugins}} type="Bar" className={chartClassName} />
  );
}

export const RegistrationsBarChart = (registrationData={}) => {
  const [labels , setLabels] = useState(null);
  const [series, setSeries] = useState(null);
  
  const generateLabelsAndSeries = (data) => {
    let new_labels = []
    let new_series = []
    data.registrationData.series.map((DistributionObject) => {
      new_labels.push(DistributionObject.country)
      new_series.push(DistributionObject.m_count_reserved)
    })
    setLabels(new_labels);
    setSeries([new_series])
  }

  useEffect(() => {
    if(registrationData !== null && registrationData !== undefined){
      generateLabelsAndSeries(registrationData)
    }
  }, [])

  return (
    <>
    {labels !== null && series !== null && (
      <HorizontalBarChart labels={labels} series={series} ></HorizontalBarChart>
    )}
    </>
  )
}
